// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack-print.classic.js, новая — rack-print.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack-print.classic';
import * as cp from './rack-print.cp';

export const RackPrint = isCp ? cp.RackPrint : classic.RackPrint;
